export const API_PATH_ApiDeviceMgmtRegionDeviceStatusSubscriptionPost = '/services/devices-mgtm/apiDeviceMgmtRegionDeviceStatusSubscriptionPost';
